export const tinkSalmon = {
  100: '#FEFBFA',
  200: '#FEF9F8',
  300: '#FEF4F0',
  400: '#FCDFD4',
  500: '#FBCAB8',
  600: '#FBBFAA',
  700: '#F89572',
  800: '#DA8364',
  900: '#CB7A5D',
};
